import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

import PropertyDamageForm from "../components/propertyDamageForm";
import Carousel from "../../../library/custom/carouselBox/Carousel";
import CarouselData from "../../../constant/carouselConstant";
import * as incidentAction from "../../../redux/actions/incidentAction";
import * as propertyDamageAction from "../../../redux/actions/propertyDamageAction";
import * as userAction from "../../../redux/actions/userAction";
import * as stateCityAction from "../../../redux/actions/stateCityAction";
import * as assetsAction from "../../../redux/actions/assetsAction";
import Loader from "../../../library/common/Loader";
import {
  API_STATUS,
  INCIDENT_REPORT_ADDED,
  INCIDENT_REPORT_UPDATE,
} from "../../../constant/constant";
import {
  PERSONAL_INJURY,
  VEHICLE_ACCIDENT,
  UTILITY_DAMAGE,
  STOLEN_PROPERTY,
  NEAR_MISS,
  PROPERTY_DAMAGE,
  DASHBOARD,
  ACCESS_DENIED,
  INCIDENT_LIST,
} from "../../../constant/routeContant";
import SuccessScreen from "../../incidents/add-incident/component/successScreen";
import { checkPrivileges } from "../../../utils/rolesHelper";
import {
  getUserBaseDivisionInfo,
  logEvent,
  validateFileSize,
} from "../../../utils/helper";
import { fileUpload } from "../../../services/fileUploadService";
import BackBtn from "../../../library/custom/backBtn/backBtn";

export default function PropertyDamageContainer() {
  const location = useLocation();
  const existingCaseId = location?.state?.caseId;
  const incidentId = location?.state?.incidentId;
  const editMode = location?.state?.editMode;
  const isDraft = location?.state?.statusId;
  const isDraftforaction = location?.state?.statusId ?? "0";
  const [successScreens, setSuccessScreens] = useState(false);
  const navigate = useNavigate();
  const disptch = useDispatch();

  const incident = useSelector((state) => state.incident.data);
  const status = useSelector((state) => state.addPropertyDamage.status);
  const addPropertyDamageData = useSelector(
    (state) => state.addPropertyDamage.data
  );
  const caseData = useSelector((state) => state.createdCase.data);
  const propertyDamageData = useSelector(
    (state) => state.getPropertyDamageReport.data
  );
  const propertyDamageDataStatus = useSelector(
    (state) => state.getPropertyDamageReport?.status
  );
  const updatePropertyDamageDataStatus = useSelector(
    (state) => state.updatePropertyDamageData.status
  );
  const updatePropertyDamageData = useSelector(
    (state) => state.updatePropertyDamageData.data
  );
  const isLoading = useSelector((state) => state.users.isLoading);
  const allUsers = useSelector((state) => state.allUsers.data);
  const searchOption = useSelector((state) => state.users.data);
  const assetOption = useSelector((state) => state.getAssetDynomoList?.data);

  const { hasBaseDivisionAdminAccess, baseDivisionIds } =
    getUserBaseDivisionInfo();

  const isAllowed = checkPrivileges([1, 2, 3, 12]);

  const isSuccess = useSelector(
    (state) =>
      state.incident.status === API_STATUS.SUCCESS &&
      (existingCaseId
        ? existingCaseId
        : state.createdCase.status === API_STATUS.SUCCESS)
  );

  const showLoader = useSelector(
    (state) =>
      state.addPropertyDamage.isLoading ||
      state.createdCase.isLoading ||
      state.updatePropertyDamageData.isLoading ||
      state.incident.isLoading ||
      state.getPropertyDamageReport.isLoading ||
      state.fileUpload.isLoading
  );

  const [dataId, setDataId] = useState("");
  const addAndUpdatePropertyDamage = async (data) => {
    setDataId(data.propertyDamage.incidentId);
    setSuccessScreens(true);
    if (data.propertyDamage.incidentId === 0) {
      disptch(propertyDamageAction.propertyDamage(data.propertyDamage));
    } else {
      disptch(propertyDamageAction.updatePropertyDamage(data.propertyDamage));
    }
  };

  const getIncidentData = () => {
    disptch(incidentAction.getIncidentData());
  };

  const [fileError, setFileError] = useState(null);
  const [countError, setCountError] = useState(0);
  const [isLoader, setIsLoader] = useState(false);
  const [fileUploadData, setFileUploadData] = useState();

  const uploadFile = async (data) => {
    const validation = validateFileSize(data);
    if (!validation.isValid) {
      setFileError(validation.errorMessage);
      setCountError(countError + 1);
      return;
    }
    setIsLoader(true);
    fileUpload(data)
      .then((res) => {
        setIsLoader(false);
        setFileUploadData({ files: res });
      })
      .catch(() => {
        setIsLoader(false);
        setCountError(countError + 1);
        setFileError("Error while uploading files.");
      });
  };

  const searchAllUsers = (searchType, searchText, projectId = 0) => {
    disptch(
      userAction.searchAllUsers(
        searchText,
        searchType,
        hasBaseDivisionAdminAccess ? baseDivisionIds : 0,
        projectId,
        1,
        0
      )
    );
  };

  // This form has no employee picker, so the project is searched directly
  // instead of being derived from a selected user.
  const searchAsset = (searchText, type) => {
    disptch(
      assetsAction.getAssetDynomoList({
        searchText,
        type,
        divisionId: hasBaseDivisionAdminAccess ? baseDivisionIds : 0,
      })
    );
  };

  const getPropertyDamageDetails = (caseIdParam, incidentIdParam) => {
    disptch(
      propertyDamageAction.getPropertyDamage(caseIdParam, incidentIdParam)
    );
  };

  useEffect(() => {
    if (!isAllowed) {
      navigate(DASHBOARD);
    }
    disptch(propertyDamageAction.clearPropertyDamage());

    if (existingCaseId && incidentId) {
      getPropertyDamageDetails(existingCaseId, incidentId);
    }
    getIncidentData();
  }, []);

  const [carouselValue, setcarouselValue] = useState({
    id: 10,
    title: "Property Damage",
  });

  const handleOnChangeMethod = (value) => {
    if (!editMode) {
      setcarouselValue(value);
      if (value.id === 1) {
        navigate(PERSONAL_INJURY, {
          state: { caseId: existingCaseId, isDirect: true },
        });
      } else if (value.id === 2) {
        navigate(VEHICLE_ACCIDENT, { state: { caseId: existingCaseId } });
      } else if (value.id === 3) {
        navigate(STOLEN_PROPERTY, { state: { caseId: existingCaseId } });
      } else if (value.id === 4) {
        navigate(UTILITY_DAMAGE, { state: { caseId: existingCaseId } });
      } else if (value.id === 5) {
        navigate(NEAR_MISS, { state: { caseId: existingCaseId } });
      } else if (value.id === 10) {
        navigate(PROPERTY_DAMAGE, { state: { caseId: existingCaseId } });
      }
    }

    if (value.id === 2) {
      disptch(stateCityAction.getState());
    }
  };

  const successScree = (id) => {
    logEvent(
      "Incident",
      editMode ? "Update Property Damage" : "Add Property Damage"
    );

    return (
      <SuccessScreen
        id={id}
        caseId={existingCaseId}
        isUpdate={dataId === 0 ? INCIDENT_REPORT_ADDED : INCIDENT_REPORT_UPDATE}
      ></SuccessScreen>
    );
  };

  const dataBack = {
    title: "Back",
    route: INCIDENT_LIST,
  };

  return (
    <>
      {editMode && <BackBtn dataBack={dataBack} className="equipmentBack" />}
      {checkPrivileges([1, 2, 12]) ? (
        <>
          <div className="loader-wrapper">
            {(showLoader || isLoader) && <Loader />}
          </div>
          <div>
            {status === API_STATUS.SUCCESS &&
            addPropertyDamageData &&
            successScreens ? (
              successScree(addPropertyDamageData?.incidentId)
            ) : updatePropertyDamageDataStatus === API_STATUS.SUCCESS &&
              updatePropertyDamageData &&
              successScreens ? (
              successScree(incidentId)
            ) : (
              <div className="dashboard-slider">
                <div>
                  <div className="dashbord_heading">
                    <div className="insi-stitle">
                      <p>Select Incident Type</p>
                      <div className="caseId">
                        Case ID: EVE-{" "}
                        {existingCaseId ? existingCaseId : caseData?.caseId}
                      </div>
                    </div>
                  </div>

                  <Carousel
                    sliderItems={CarouselData}
                    activeSlide={carouselValue}
                    handleOnChange={handleOnChangeMethod}
                    edit={editMode ? true : false}
                  />
                </div>

                <div>
                  {isSuccess && (
                    <PropertyDamageForm
                      incident={incident}
                      caseId={existingCaseId ? existingCaseId : caseData?.caseId}
                      incidentId={incidentId ? incidentId : 0}
                      caseData={caseData}
                      searchOption={searchOption}
                      searchAllUsers={searchAllUsers}
                      allUsers={allUsers}
                      onSubmit={addAndUpdatePropertyDamage}
                      propertyDamageData={incidentId ? propertyDamageData : ""}
                      propertyDamageDataStatus={propertyDamageDataStatus}
                      uploadFile={uploadFile}
                      fileUploadData={fileUploadData}
                      editMode={editMode}
                      isLoading={isLoading}
                      fileError={fileError}
                      countError={countError}
                      isDraft={isDraft}
                      isDraftforaction={isDraftforaction}
                      assetOption={assetOption}
                      searchAsset={searchAsset}
                    />
                  )}
                </div>
              </div>
            )}
          </div>
        </>
      ) : (
        navigate(ACCESS_DENIED)
      )}
    </>
  );
}
